import { render, staticRenderFns } from "./courseLxps.vue?vue&type=template&id=e7c8d206&scoped=true&"
import script from "./courseLxps.vue?vue&type=script&lang=js&"
export * from "./courseLxps.vue?vue&type=script&lang=js&"
import style0 from "./courseLxps.vue?vue&type=style&index=0&id=e7c8d206&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c8d206",
  null
  
)

export default component.exports